const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/docs/coaching-plans/$coachingPlanId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/docs/coaching-plans/$coachingPlanId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}